module.exports = __webpack_public_path__ + "static/img/sl-2.2848903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/sl-2.png
// module id = AFf2
// module chunks = 0